<template>
  <v-container class="mx_h empresas-index-page" fluid>
    <v-layout row wrap fill-height>

      <!-- ───── DETALHE DA EMPRESA (MODAL 80x80) ───── -->
      <v-flex xs12>

        <!-- Dialog plano -->
        <v-dialog v-model="planoinfoShow" max-width="800">
          <v-card>
            <v-card-title>Detalhes do plano contratado</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <h2 style="color:orange"><strong>{{ empresainfos.nome }}</strong></h2>
                </v-col>
                <v-col cols="12">
                  <v-simple-table dense>
                    <tr><th>Serviço</th><th>Limite transações</th><th>Valor unitário (Excedente)</th></tr>
                    <tbody>
                      <tr v-for="item in (empresainfos.plano && empresainfos.plano.servicos) || []" :key="item.id">
                        <td class="text-center">{{ item.descricao }}</td>
                        <td class="text-center">{{ item.qt_max }}</td>
                        <td class="text-center">{{ converterDinherio(item.preco_venda) }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-card-actions class="justify-end">
                <h3 style="color:black">Valor do Plano: {{ empresainfos.plano ? converterDinherio(empresainfos.plano.total) : '-' }}</h3>
              </v-card-actions>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="planoinfoShow = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Loading overlay -->
        <v-progress-linear v-if="ldn_detalhes" color="orange" indeterminate fixed top style="z-index:99"></v-progress-linear>

        <v-dialog
          v-model="dialogDetalhes"
          scrollable
          max-width="80vw"
          content-class="empresa-detalhes-modal"
        >
        <div class="detalhe-page">

          <!-- ══ HERO HEADER ══ -->
          <div class="detalhe-hero">
            <div class="detalhe-hero__inner">

              <!-- Logo clicável -->
              <div class="detalhe-hero__logo" @click="triggerLogoInput" title="Clique para alterar o logo">
                <v-avatar size="72" color="white" class="detalhe-hero__avatar">
                  <v-img v-if="logoUrl" :src="logoUrl" contain></v-img>
                  <v-icon v-else color="#0052A0" size="40">mdi-domain</v-icon>
                </v-avatar>
                <div class="detalhe-hero__logo-overlay">
                  <v-icon color="white" size="20">mdi-camera</v-icon>
                </div>
              </div>
              <input ref="logoInputHidden" type="file" accept="image/*" style="display:none" @change="onLogoSelectedFromHeader" />

              <!-- Info -->
              <div class="detalhe-hero__info">
                <h1 class="detalhe-hero__name">{{ empresainfos.name || 'Detalhes da Empresa' }}</h1>
                <div class="detalhe-hero__meta">
                  <v-chip small :color="empresainfos.status === 'Ativo' ? '#22c55e' : '#f59e0b'" dark class="mr-2">
                    <v-icon x-small left>mdi-circle</v-icon>
                    {{ empresainfos.status || 'Em análise' }}
                  </v-chip>
                  <span v-if="empresainfos.cpf_cnpj" class="detalhe-hero__cnpj">{{ formatarCpfCnpj(empresainfos.cpf_cnpj) }}</span>
                </div>
              </div>

              <!-- Ação completar cadastro -->
              <div class="detalhe-hero__actions">
                <v-btn
                  v-if="empresainfos.status != 'Ativo' && empresainfos.etapa < 5"
                  color="#FFD400"
                  elevation="0"
                  rounded
                  @click="completarCadastro(empresainfos.id, empresainfos.user_juridica)"
                >
                  <v-icon left small color="#0052A0">mdi-alert-circle</v-icon>
                  <span style="color:#0052A0;font-weight:700">Completar Cadastro</span>
                </v-btn>
              </div>
            </div>
          </div>

          <!-- ══ BODY: sidenav + sections ══ -->
          <div class="detalhe-body" ref="detalheBody">

            <!-- NAV lateral (sticky) -->
            <aside class="detalhe-sidenav">
              <nav>
                <button
                  v-for="sec in sections"
                  :key="sec.id"
                  class="sidenav-item"
                  :class="{ 'sidenav-item--active': activeSection === sec.id }"
                  @click="scrollToSection(sec.id)"
                >
                  <v-icon small class="sidenav-item__icon">{{ sec.icon }}</v-icon>
                  {{ sec.label }}
                </button>
              </nav>
            </aside>

            <!-- CONTENT -->
            <main class="detalhe-content" ref="detalheContent" @scroll="onContentScroll">

              <!-- ── SECTION: Identidade Visual ── -->
              <section id="sec-logo" class="detalhe-section">
                <div class="section-header">
                  <div class="section-header__icon-wrap">
                    <v-icon color="#0052A0">mdi-image-outline</v-icon>
                  </div>
                  <div>
                    <div class="section-header__title">Identidade Visual</div>
                    <div class="section-header__sub">Logo exibido nas comunicações e documentos da empresa</div>
                  </div>
                </div>

                <div class="section-body">
                  <div class="logo-upload-card">
                    <div class="logo-upload-preview">
                      <v-avatar v-if="logoUrl" size="140" class="logo-upload-avatar">
                        <v-img :src="logoUrl" contain></v-img>
                      </v-avatar>
                      <div v-else class="logo-upload-placeholder">
                        <v-icon size="56" color="#cbd5e1">mdi-image-outline</v-icon>
                        <span class="logo-upload-placeholder__text">Sem logo</span>
                      </div>
                    </div>
                    <div class="logo-upload-controls">
                      <v-file-input
                        v-model="logoFile"
                        accept="image/*"
                        label="Selecionar arquivo"
                        prepend-icon="mdi-camera"
                        show-size
                        :loading="uploadingLogo"
                        @change="onLogoSelected"
                        hide-details
                        outlined
                        dense
                        class="mb-3"
                      ></v-file-input>
                      <p class="logo-upload-hint">JPG, PNG ou SVG · Recomendado 400×400px · Máx. 2MB</p>
                      <div class="d-flex flex-wrap" style="gap:8px">
                        <v-btn
                          color="#0052A0"
                          :disabled="!logoFile"
                          :loading="uploadingLogo"
                          @click="uploadLogo"
                          elevation="0"
                          rounded
                          class="px-6"
                        >
                          <v-icon color="#FFD400" small class="mr-1">mdi-upload</v-icon>
                          <span style="color:#FFD400;font-weight:700;font-size:13px">Enviar logo</span>
                        </v-btn>
                        <v-btn
                          v-if="logoUrl"
                          color="error"
                          outlined
                          :loading="removingLogo"
                          @click="removerLogo"
                          rounded
                          elevation="0"
                          class="px-6"
                        >
                          <v-icon small class="mr-1">mdi-delete-outline</v-icon>
                          <span style="font-size:13px">Remover</span>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <!-- ── SECTION: Dados Cadastrais ── -->
              <section id="sec-cadastrais" class="detalhe-section">
                <div class="section-header">
                  <div class="section-header__icon-wrap">
                    <v-icon color="#0052A0">mdi-card-account-details-outline</v-icon>
                  </div>
                  <div>
                    <div class="section-header__title">Dados Cadastrais</div>
                    <div class="section-header__sub">Informações de identificação e endereço da empresa</div>
                  </div>
                </div>

                <div class="section-body">
                  <!-- Identificação -->
                  <div class="info-group">
                    <div class="info-group__label">Identificação</div>
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">Razão Social</span>
                          <span class="info-chip-field__value">{{ empresainfos.name || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">CNPJ / CPF</span>
                          <span class="info-chip-field__value">{{ formatarCpfCnpj(empresainfos.cpf_cnpj) || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">Nome Fantasia</span>
                          <span class="info-chip-field__value">{{ empresainfos.nameFantasy || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">E-mail</span>
                          <span class="info-chip-field__value">{{ empresainfos.email2 || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">Telefone</span>
                          <span class="info-chip-field__value">{{ empresainfos.telefone || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">WhatsApp</span>
                          <span class="info-chip-field__value">{{ empresainfos.whats || '—' }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Endereço -->
                  <div class="info-group mt-4">
                    <div class="info-group__label">Endereço</div>
                    <v-row dense>
                      <v-col cols="12" md="7">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">Logradouro</span>
                          <span class="info-chip-field__value">{{ empresainfos.endereco || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="6" md="2">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">Número</span>
                          <span class="info-chip-field__value">{{ empresainfos.numero || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="6" md="3">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">Complemento</span>
                          <span class="info-chip-field__value">{{ empresainfos.complemento || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">Bairro</span>
                          <span class="info-chip-field__value">{{ empresainfos.bairro || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">Município</span>
                          <span class="info-chip-field__value">{{ empresainfos.municipio || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="4" md="2">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">UF</span>
                          <span class="info-chip-field__value">{{ empresainfos.uf || '—' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="8" md="2">
                        <div class="info-chip-field">
                          <span class="info-chip-field__label">CEP</span>
                          <span class="info-chip-field__value">{{ empresainfos.cep || '—' }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </section>

              <!-- ── SECTION: Dados Bancários ── -->
              <section id="sec-bancarios" class="detalhe-section">
                <div class="section-header">
                  <div class="section-header__icon-wrap">
                    <v-icon color="#0052A0">mdi-bank-outline</v-icon>
                  </div>
                  <div>
                    <div class="section-header__title">Dados Bancários</div>
                    <div class="section-header__sub">Conta utilizada para liquidação e repasses</div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-chip small color="#e8f0fe" class="ml-2" style="color:#0052A0;font-weight:600">
                    <v-icon x-small left color="#0052A0">mdi-pencil</v-icon>
                    Editável
                  </v-chip>
                </div>

                <div class="section-body">
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="empresainfos.banco"
                        label="Banco"
                        outlined
                        dense
                        color="#0052A0"
                        prepend-inner-icon="mdi-bank"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="empresainfos.agencia"
                        label="Agência"
                        outlined
                        dense
                        color="#0052A0"
                        prepend-inner-icon="mdi-numeric"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="empresainfos.conta"
                        label="Conta Corrente"
                        outlined
                        dense
                        color="#0052A0"
                        prepend-inner-icon="mdi-credit-card-outline"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </section>

              <!-- ── SECTION: Comunicação ── -->
              <section id="sec-comunicacao" class="detalhe-section">
                <div class="section-header">
                  <div class="section-header__icon-wrap">
                    <v-icon color="#0052A0">mdi-email-outline</v-icon>
                  </div>
                  <div>
                    <div class="section-header__title">Canais de Comunicação</div>
                    <div class="section-header__sub">Dados exibidos em notificações enviadas ao devedor</div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-chip small color="#e8f0fe" class="ml-2" style="color:#0052A0;font-weight:600">
                    <v-icon x-small left color="#0052A0">mdi-pencil</v-icon>
                    Editável
                  </v-chip>
                </div>

                <div class="section-body">
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="empresainfos.comunicacao_email"
                        label="E-mail"
                        placeholder="sac@empresa.com.br"
                        outlined
                        dense
                        color="#0052A0"
                        prepend-inner-icon="mdi-email-outline"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="empresainfos.comunicacao_site"
                        label="Site Institucional"
                        placeholder="https://empresa.com.br"
                        outlined
                        dense
                        color="#0052A0"
                        prepend-inner-icon="mdi-web"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="empresainfos.comunicacao_telefone"
                        v-phone:model="empresainfos.comunicacao_telefone"
                        label="Telefone"
                        outlined
                        dense
                        color="#0052A0"
                        prepend-inner-icon="mdi-phone-outline"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </section>

              <!-- ── SECTION: Contratação ── -->
              <section id="sec-contratacao" class="detalhe-section">
                <div class="section-header">
                  <div class="section-header__icon-wrap">
                    <v-icon color="#0052A0">mdi-file-document-outline</v-icon>
                  </div>
                  <div>
                    <div class="section-header__title">Contratação</div>
                    <div class="section-header__sub">Plano ativo e vigência do contrato</div>
                  </div>
                </div>

                <div class="section-body">
                  <div class="contratacao-grid">
                    <div class="contratacao-card">
                      <div class="contratacao-card__label">Data de cadastro</div>
                      <div class="contratacao-card__value">
                        {{ empresainfos.created_at ? moment(empresainfos.created_at).format('DD/MM/YYYY') : '—' }}
                      </div>
                    </div>
                    <div class="contratacao-card contratacao-card--plan" @click="detalhesPlano(empresainfos.plano_id)" title="Ver detalhes do plano">
                      <div class="contratacao-card__label">Plano contratado</div>
                      <div class="contratacao-card__value contratacao-card__value--link">
                        {{ empresainfos.nome || '—' }}
                        <v-icon x-small color="#0052A0" class="ml-1">mdi-open-in-new</v-icon>
                      </div>
                    </div>
                    <div class="contratacao-card">
                      <div class="contratacao-card__label">Status</div>
                      <div class="contratacao-card__value">
                        <v-chip small :color="empresainfos.status === 'Ativo' ? '#22c55e' : '#f59e0b'" dark>
                          {{ empresainfos.status === 'Em análise' ? 'Aguardando validação' : (empresainfos.status || '—') }}
                        </v-chip>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <!-- ── SECTION: Usuários ── -->
              <section id="sec-usuarios" class="detalhe-section detalhe-section--last">
                <div class="section-header">
                  <div class="section-header__icon-wrap">
                    <v-icon color="#0052A0">mdi-account-group-outline</v-icon>
                  </div>
                  <div>
                    <div class="section-header__title">Usuários Vinculados</div>
                    <div class="section-header__sub">Pessoas com acesso a esta empresa na plataforma</div>
                  </div>
                </div>

                <div class="section-body">
                  <v-data-table
                    :headers="[
                      { text: 'Nome', value: 'name' },
                      { text: 'E-mail', value: 'email' },
                      { text: 'Status', value: 'status', align: 'center', width: '120' }
                    ]"
                    :items="empresainfos.usuarios || []"
                    :items-per-page="5"
                    class="elevation-0 usuarios-table"
                    no-data-text="Nenhum usuário vinculado"
                    hide-default-footer
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip small :color="item.status === 'ativo' ? '#22c55e' : '#94a3b8'" dark>
                        {{ item.status === 'ativo' ? 'Ativo' : 'Inativo' }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </div>
              </section>

            </main>
          </div>

          <!-- ══ FOOTER FIXO ══ -->
          <div class="detalhe-footer">
            <div class="detalhe-footer__inner">
              <v-btn text rounded @click="fecharDetalhes" class="mr-2" color="grey darken-1">
                <v-icon left small>mdi-arrow-left</v-icon>
                Voltar
              </v-btn>
              <v-btn color="#0052A0" rounded elevation="0" @click="salvarModificacoes()" :loading="ldn_detalhes" class="px-8">
                <v-icon left color="#FFD400" small>mdi-content-save-outline</v-icon>
                <span style="color:#FFD400;font-weight:700">Salvar alterações</span>
              </v-btn>
            </div>
          </div>

        </div>
        </v-dialog>
      </v-flex>

      <!-- ───── LISTAGEM DE EMPRESAS ───── -->
      <v-flex xs12 class="mx_h">
        <v-card :loading="lgn_table" class="mx_h empresas-list-card" elevation="0">
          <template slot="progress">
            <v-progress-linear color="primary" indeterminate></v-progress-linear>
          </template>

          <!-- ── Banner explicativo: fluxo de aprovação ── -->
          <div v-if="temCadastroPendente" class="fluxo-banner">
            <div class="fluxo-banner__icon-wrap">
              <v-icon color="#0052A0" size="22">mdi-clipboard-check-outline</v-icon>
            </div>
            <div class="fluxo-banner__text">
              <div class="fluxo-banner__title">Seu cadastro está em análise</div>
              <div class="fluxo-banner__body">
                Por segurança, cada credor é revisado manualmente pela nossa equipe antes de liberar o
                acesso completo à plataforma (negativação, protocolos e relatórios). Isso é normal e não
                significa que algo deu errado — assim que a análise terminar, você recebe um e-mail e as
                funcionalidades são liberadas automaticamente. Esse processo costuma ser rápido.
              </div>
            </div>
          </div>

          <div class="empresas-list-card__actions">
            <v-btn
              color="#0052A0"
              rounded
              elevation="0"
              class="empresas-list-card__cta px-5"
              @click="cadastrarEmpresa"
            >
              <v-icon small left color="#FFD400">mdi-plus-circle</v-icon>
              <span style="color:#FFD400;font-weight:700;font-size:13px">Cadastrar novo credor</span>
            </v-btn>
          </div>
          <v-card-text class="empresas-list-card__content">
            <v-data-table
              :items="list"
              :footer-props="{
                'items-per-page-text': 'Registros por página: ',
                'page-text': '{0}-{1} de {2}',
                'items-per-page-all-text': 'Listar todos',
              }"
              class="empresas-list-table"
              :headers="[
                { text: 'CNPJ / CPF' },
                { text: 'Nome/Razão social' },
                { text: 'Data de solicitação' },
                { text: 'Status', align: 'center' },
                { text: 'Ações' },
              ]"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ formatarCpfCnpj(item.cpf_cnpj) }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.created_at ? moment(item.created_at).format('DD/MM/YYYY') : '—' }}</td>
                  <td class="text-center">
                    <v-tooltip top max-width="280" v-if="item.status != 'Ativo'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          v-if="item.status == 'Em análise'"
                          small
                          outlined
                          color="warning"
                          class="status-chip status-chip--click"
                          v-bind="attrs"
                          v-on="on"
                          @click="aguardandoInfo"
                        >
                          <v-icon x-small left>mdi-clock-outline</v-icon>
                          {{ item.status }}
                        </v-chip>
                        <v-chip
                          v-else
                          small
                          outlined
                          color="grey"
                          class="status-chip status-chip--click"
                          v-bind="attrs"
                          v-on="on"
                          @click="completarCadastro(item.empresa_id, item.user_juridica)"
                        >
                          <v-icon x-small left>mdi-alert-circle-outline</v-icon>
                          Cadastro Incompleto
                        </v-chip>
                      </template>
                      <span v-if="item.status == 'Em análise'">Aguardando revisão da nossa equipe. Clique para saber mais.</span>
                      <span v-else>Faltam etapas para concluir o cadastro. Clique para continuar.</span>
                    </v-tooltip>
                    <v-chip
                      v-else
                      small
                      outlined
                      color="success"
                      class="status-chip"
                    >
                      <v-icon x-small left>mdi-check-circle-outline</v-icon>
                      {{ item.status }}
                    </v-chip>
                  </td>
                  <td class="text-center">
                    <v-btn
                      small
                      depressed
                      outlined
                      color="primary"
                      class="btn-visualizar"
                      @click="informacoesEmpresa(item.empresa_id)"
                    >
                      <v-icon small left color="primary">mdi-eye</v-icon>
                      Visualizar
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <div class="empty-state">
                  <v-icon size="48" color="#cbd5e1">mdi-domain-off</v-icon>
                  <div class="empty-state__title">Nenhum credor cadastrado</div>
                  <div class="empty-state__body">
                    Você ainda não cadastrou os dados da sua empresa. Isso é necessário para liberar o
                    acesso às funcionalidades de negativação, protocolos e relatórios.
                  </div>
                  <v-btn
                    color="#0052A0"
                    rounded
                    elevation="0"
                    class="px-6 mt-3"
                    @click="cadastrarEmpresa"
                  >
                    <v-icon small left color="#FFD400">mdi-plus-circle</v-icon>
                    <span style="color:#FFD400;font-weight:700;font-size:13px">Cadastrar meu primeiro credor</span>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import helper from "../../mixins/helper";

export default {
  mixins: [helper],
  components: {},

  computed: {
    temCadastroPendente() {
      return this.list.some((e) => e.status != 'Ativo');
    },
  },

  data: () => ({
    loading: false,
    lgn_table: false,
    pagination: [],

    empresainfos: {
      plano: { servicos: [] },
    },
    dialogDetalhes: false,
    ldn_detalhes: false,
    planoinfoShow: false,
    list: [],
    items: [],

    activeTab: 0,
    logoFile: null,
    logoUrl: null,
    uploadingLogo: false,
    removingLogo: false,

    activeSection: 'sec-logo',

    sections: [
      { id: 'sec-logo',        label: 'Identidade Visual', icon: 'mdi-image-outline' },
      { id: 'sec-cadastrais',  label: 'Dados Cadastrais',  icon: 'mdi-card-account-details-outline' },
      { id: 'sec-bancarios',   label: 'Dados Bancários',   icon: 'mdi-bank-outline' },
      { id: 'sec-comunicacao', label: 'Comunicação',       icon: 'mdi-email-outline' },
      { id: 'sec-contratacao', label: 'Contratação',       icon: 'mdi-file-document-outline' },
      { id: 'sec-usuarios',    label: 'Usuários',          icon: 'mdi-account-group-outline' },
    ],
  }),

  mounted() {
    this.getEmpresas();
  },

  methods: {
    // ── Scroll & nav ──────────────────────────────────
    scrollToSection(id) {
      const content = this.$refs.detalheContent;
      const el = content ? content.querySelector('#' + id) : null;
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.activeSection = id;
      }
    },

    onContentScroll() {
      const content = this.$refs.detalheContent;
      if (!content) return;
      const scrollTop = content.scrollTop + 80;
      for (const sec of this.sections) {
        const el = content.querySelector('#' + sec.id);
        if (el && el.offsetTop <= scrollTop) {
          this.activeSection = sec.id;
        }
      }
    },

    // ── Logo via header click ─────────────────────────
    triggerLogoInput() {
      this.$refs.logoInputHidden.click();
    },

    onLogoSelectedFromHeader(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.logoFile = file;
      const reader = new FileReader();
      reader.onload = (ev) => { this.logoUrl = ev.target.result; };
      reader.readAsDataURL(file);
    },

    // ── Dados ─────────────────────────────────────────
    getEmpresas() {
      this.lgn_table = true;
      this.$http.get("getEmpresa").then(
        (response) => { this.list = response.data; this.lgn_table = false; },
        () => { this.lgn_table = false; }
      );
    },

    detalhesPlano() {
      this.planoinfoShow = true;
    },

    mphone(v) {
      var r = v.replace(/\D/g, "");
      r = r.replace(/^0/, "");
      if (r.length > 10)      r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
      else if (r.length > 5)  r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
      else if (r.length > 2)  r = r.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
      else                    r = r.replace(/^(\d*)/, "($1");
      return r;
    },

    aguardandoInfo() {
      this.$swal({
        toast: false,
        position: "top-center",
        showConfirmButton: true,
        icon: "info",
        confirmButtonColor: "#0052A0",
        title: "Cadastro em análise",
        html: "Por segurança, nossa equipe revisa manualmente os dados e documentos de cada credor antes de liberar o acesso completo à plataforma. Você será avisado por e-mail assim que a análise for concluída — esse processo costuma ser rápido. Obrigado pela paciência!",
      });
    },

    async salvarModificacoes() {
      this.ldn_detalhes = true;
      let empresa_id = this.empresainfos.empresa_id;
      let dataForm = this.empresainfos;
      this.$http.post("edicaoEmpresa/" + empresa_id, dataForm).then(
        () => {
          this.$swal({ toast: false, position: "top-center", showConfirmButton: true, icon: "success", title: "Cadastro atualizado com sucesso" });
          this.dialogDetalhes = false;
          this.ldn_detalhes = false;
        },
        (error) => { console.log(error); this.ldn_detalhes = false; }
      );
    },

    async informacoesEmpresa(empresa_id) {
      this.ldn_detalhes = true;
      this.dialogDetalhes = true;
      this.empresainfos = { plano: { servicos: [] } };
      this.logoFile = null;
      this.logoUrl = null;

      await this.$http.get("empresaInformacoes/" + empresa_id).then(
        (response) => {
          this.empresainfos = { ...response.data, plano: response.data.plano || { servicos: [] } };
          this.empresainfos.id = empresa_id;
          if (this.empresainfos.logo_path) this.carregarLogo(empresa_id);
          this.ldn_detalhes = false;
        },
        () => { this.ldn_detalhes = false; }
      );

      this.empresainfos.empresa_id = empresa_id;
    },

    fecharDetalhes() {
      this.dialogDetalhes = false;
    },

    navigate(page) {
      this.$http.get("getEmpresa?page=" + page).then(
        (response) => { this.list = response.data.data; this.pagination = response.data; },
        (response) => { console.log(response); }
      );
    },

    cadastrarEmpresa() {
      this.$router.push({ name: "Cadastro de Credor" });
    },

    completarCadastro(empresa_id, is_juridica) {
      this.$router.push({ name: "Cadastro de Credor", params: { empresa_id, tipo_fj: is_juridica } });
    },

    onLogoSelected(file) {
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => { this.logoUrl = e.target.result; };
        reader.readAsDataURL(file);
      }
    },

    async uploadLogo() {
      if (!this.logoFile) return;
      this.uploadingLogo = true;
      const formData = new FormData();
      formData.append('logo', this.logoFile);
      try {
        await this.$http.post(`empresa/${this.empresainfos.id}/upload-logo`, formData);
        this.$swal({ toast: false, position: "top-center", showConfirmButton: true, icon: "success", title: "Logo enviado com sucesso" });
        this.logoFile = null;
        await this.carregarLogo(this.empresainfos.id);
      } catch (error) {
        this.$swal({ toast: false, position: "top-center", showConfirmButton: true, icon: "error", title: "Erro ao enviar logo", text: error.data?.erro || error.data?.message || "Não foi possível enviar o logo" });
      } finally {
        this.uploadingLogo = false;
      }
    },

    async removerLogo() {
      const result = await this.$swal({ title: 'Confirmar remoção?', text: "Deseja realmente remover o logo da empresa?", icon: 'warning', showCancelButton: true, confirmButtonColor: '#d33', cancelButtonColor: '#3085d6', confirmButtonText: 'Sim, remover', cancelButtonText: 'Cancelar' });
      if (!result.isConfirmed) return;
      this.removingLogo = true;
      try {
        await this.$http.delete(`empresa/${this.empresainfos.id}/remover-logo`);
        this.$swal({ toast: false, position: "top-center", showConfirmButton: true, icon: "success", title: "Logo removido com sucesso" });
        if (this.logoUrl && this.logoUrl.startsWith("blob:")) {
          URL.revokeObjectURL(this.logoUrl);
        }
        this.logoUrl = null;
        this.logoFile = null;
        await this.carregarLogo(this.empresainfos.id);
      } catch (error) {
        console.error(error);
        this.$swal({ toast: false, position: "top-center", showConfirmButton: true, icon: "error", title: "Erro ao remover logo", text: error.data?.message || "Não foi possível remover o logo" });
      } finally {
        this.removingLogo = false;
      }
    },

    async carregarLogo(empresa_id) {
      try {
        const response = await this.$http.get(
          `empresa/${empresa_id}/logo?t=${Date.now()}`,
          { responseType: 'blob' }
        );

        if (this.logoUrl && this.logoUrl.startsWith("blob:")) {
          URL.revokeObjectURL(this.logoUrl);
        }

        if (response.data && response.data.size > 0) {
          this.logoUrl = URL.createObjectURL(response.data);
        } else {
          this.logoUrl = null;
        }
      } catch {
        if (this.logoUrl && this.logoUrl.startsWith("blob:")) {
          URL.revokeObjectURL(this.logoUrl);
        }
        this.logoUrl = null;
      }
    },
  },
};
</script>

<style scoped>
/* ─── Reset & base ─────────────────────────────────── */
.mx_h { height: 100%; }

.empresas-index-page {
  padding: 14px 14px 10px !important;
  background: #fff;
}

.fluxo-banner {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #eef4fc;
  border: 1px solid #d9e6f7;
  border-radius: 10px;
  padding: 16px 18px;
  margin: 0 0 16px 0;
}
.fluxo-banner__icon-wrap {
  width: 38px;
  height: 38px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.fluxo-banner__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.92rem;
  font-weight: 700;
  color: #0052A0;
  margin-bottom: 4px;
}
.fluxo-banner__body {
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  color: #475569;
  line-height: 1.55;
}

.empresas-list-card__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 16px 0;
}

.empresas-list-card__cta {
  font-family: 'Inter', sans-serif !important;
  font-weight: 700 !important;
  text-transform: none;
  letter-spacing: 0;
  border-radius: 8px !important;
  white-space: nowrap;
}

.empresas-list-card {
  border-radius: 0 !important;
  border: none !important;
  background: #fff;
  box-shadow: none !important;
}

.empresas-list-card__content {
  padding: 0;
}

.empresas-list-table >>> th {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  color: #64748b !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #f8fafc !important;
}

.empresas-list-table >>> td {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.875rem !important;
  color: #1e293b !important;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
}
.empty-state__title {
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  margin-top: 12px;
}
.empty-state__body {
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.55;
  max-width: 420px;
  margin-top: 6px;
}

.status-chip {
  font-family: 'Inter', sans-serif !important;
  font-weight: 600 !important;
  font-size: 0.72rem !important;
  letter-spacing: 0.02em;
}

.status-chip--click {
  cursor: pointer;
}

.btn-visualizar {
  font-family: 'Inter', sans-serif !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  border-radius: 8px !important;
}

/* ─── Página de detalhe ─────────────────────────────── */
.detalhe-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f0f4f8;
}

/* ─── Hero header ───────────────────────────────────── */
.detalhe-hero {
  background: linear-gradient(135deg, #0052A0 0%, #013668 100%);
  padding: 24px 32px;
  flex-shrink: 0;
}
.detalhe-hero__inner {
  display: flex;
  align-items: center;
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}
.detalhe-hero__logo {
  position: relative;
  cursor: pointer;
  flex-shrink: 0;
}
.detalhe-hero__avatar {
  border: 3px solid rgba(255,255,255,0.25) !important;
  box-shadow: 0 4px 16px rgba(0,0,0,0.2);
  transition: transform 0.2s;
}
.detalhe-hero__logo:hover .detalhe-hero__avatar {
  transform: scale(1.04);
}
.detalhe-hero__logo-overlay {
  position: absolute;
  bottom: 0; right: 0;
  width: 24px; height: 24px;
  background: #FFD400;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 2px 6px rgba(0,0,0,0.25);
}
.detalhe-hero__info {
  flex: 1;
  min-width: 0;
}
.detalhe-hero__name {
  color: #fff;
  font-size: 1.45rem;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detalhe-hero__meta {
  display: flex;
  align-items: center;
  margin-top: 6px;
  flex-wrap: wrap;
  gap: 6px;
}
.detalhe-hero__cnpj {
  color: rgba(255,255,255,0.75);
  font-size: 0.875rem;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
}
.detalhe-hero__actions {
  flex-shrink: 0;
}

/* ─── Body (sidenav + content) ─────────────────────── */
.detalhe-body {
  display: flex;
  flex: 1;
  overflow: hidden;
  max-width: 100%;
}

/* ─── Sidenav ───────────────────────────────────────── */
.detalhe-sidenav {
  width: 220px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #e2e8f0;
  padding: 24px 12px;
  overflow-y: auto;
}
.sidenav-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 9px 12px;
  margin-bottom: 2px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
  color: #64748b;
  text-align: left;
  transition: background 0.15s, color 0.15s;
  gap: 8px;
}
.sidenav-item:hover {
  background: #f1f5f9;
  color: #0052A0;
}
.sidenav-item--active {
  background: #e8f0fe !important;
  color: #0052A0 !important;
  font-weight: 700;
}
.sidenav-item__icon {
  opacity: 0.75;
}
.sidenav-item--active .sidenav-item__icon {
  opacity: 1;
}

/* ─── Content (scrollable) ─────────────────────────── */
.detalhe-content {
  flex: 1;
  overflow-y: auto;
  padding: 32px 40px;
  scroll-behavior: smooth;
}

/* ─── Section ───────────────────────────────────────── */
.detalhe-section {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  margin-bottom: 24px;
  overflow: hidden;
  scroll-margin-top: 24px;
}
.detalhe-section--last {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  background: #fafbfd;
}
.section-header__icon-wrap {
  width: 36px; height: 36px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.section-header__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.3;
}
.section-header__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.8rem;
  color: #94a3b8;
  margin-top: 2px;
}
.section-body {
  padding: 20px 24px;
}

/* ─── Info fields (read-only) ───────────────────────── */
.info-group {
  margin-bottom: 4px;
}
.info-group__label {
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #94a3b8;
  margin-bottom: 10px;
}
.info-chip-field {
  margin-bottom: 12px;
}
.info-chip-field__label {
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 0.72rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.info-chip-field__value {
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 0.92rem;
  font-weight: 500;
  color: #1e293b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 9px 14px;
  min-height: 40px;
  line-height: 1.4;
}

/* ─── Contratação cards ─────────────────────────────── */
.contratacao-grid {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.contratacao-card {
  flex: 1;
  min-width: 160px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px 18px;
}
.contratacao-card--plan {
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.contratacao-card--plan:hover {
  background: #e8f0fe;
  border-color: #0052A0;
}
.contratacao-card__label {
  font-family: 'Inter', sans-serif;
  font-size: 0.72rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}
.contratacao-card__value {
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
}
.contratacao-card__value--link {
  color: #0052A0;
  display: flex;
  align-items: center;
}

/* ─── Logo upload ───────────────────────────────────── */
.logo-upload-card {
  display: flex;
  align-items: flex-start;
  gap: 32px;
  flex-wrap: wrap;
}
.logo-upload-preview {
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-upload-avatar {
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
  border: 2px solid #e2e8f0 !important;
}
.logo-upload-placeholder {
  width: 140px; height: 140px;
  border: 2px dashed #cbd5e1;
  border-radius: 50%;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  background: #f8fafc;
}
.logo-upload-placeholder__text {
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 4px;
}
.logo-upload-controls {
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.logo-upload-hint {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #94a3b8;
  margin-bottom: 12px;
  margin-top: 4px;
}

/* ─── Tabela usuários ───────────────────────────────── */
.usuarios-table >>> th {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 700 !important;
  color: #64748b !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #f8fafc !important;
}
.usuarios-table >>> td {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.88rem !important;
  color: #1e293b !important;
}

/* ─── Footer fixo ───────────────────────────────────── */
.detalhe-footer {
  background: #fff;
  border-top: 1px solid #e2e8f0;
  padding: 12px 32px;
  flex-shrink: 0;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.04);
}
.detalhe-footer__inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

/* ─── Responsivo (mobile) ───────────────────────────── */
@media (max-width: 768px) {
  .empresas-list-card__actions {
    justify-content: stretch;
  }
  .empresas-list-card__cta {
    width: 100%;
    justify-content: center;
  }
  .detalhe-sidenav { display: none; }
  .detalhe-content { padding: 16px; }
  .detalhe-hero { padding: 16px; }
  .detalhe-hero__name { font-size: 1.1rem; }
  .logo-upload-card { flex-direction: column; align-items: center; }
  .contratacao-grid { flex-direction: column; }
}
</style>

<style>
.empresa-detalhes-modal {
  width: 80vw;
  max-width: 80vw;
  height: 80vh;
  max-height: 80vh;
  margin: auto;
}

.empresa-detalhes-modal .v-card {
  height: 80vh;
  max-height: 80vh;
  overflow: hidden;
  border-radius: 14px;
}

.empresas-index-page .v-data-table td,
.detalhe-page .v-simple-table td,
.detalhe-page .v-data-table td {
  font-family: "Inter", sans-serif;
  color: rgba(0, 0, 0, 0.87) !important;
}
.detalhe-page p { color: #4a4949; }
</style>
